import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Zap, CreditCard, Users } from 'lucide-react';
import heroBg from "../../assets/hero-bg2.jpeg"; // Import background image

const proofPoints = [
    {
        title: "AI/Infrastructure Focus",
        description: "Backing application-layer AI, devtools/security, and compute/infrastructure that compound over a decade.",
        icon: <Zap className="w-6 h-6 text-cyan-400" />,
        color: "text-cyan-400",
    },
    {
        title: "Cross-Border Execution",
        description: "Cross-border company-building: entity setup, go-to-market, and regulatory pathways in EU, GCC, and India.",
        icon: <Briefcase className="w-6 h-6 text-blue-400" />,
        color: "text-blue-400",
    },
    {
        title: "Global Access & Velocity",
        description: "Multi-office presence for founder access and local execution velocity.",
        icon: <Users className="w-6 h-6 text-purple-400" />,
        color: "text-purple-400",
    },
    {
        title: "Integrated Capital Strategy",
        description: "Access to both equity (Ventures) and non-dilutive financing (Amama Bypass).",
        icon: <CreditCard className="w-6 h-6 text-pink-400" />,
        color: "text-pink-400",
    },
];

const SubHeroProofPoints = () => {
    return (
        <section className="relative py-4 md:py-8 overflow-hidden text-white">

            {/* z-0: Background Image with Overlay (Fixed Parallax Effect) */}
            <div
                className="absolute inset-0 z-0"
                style={{
                    backgroundImage: `url(${heroBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    backgroundAttachment: 'fixed',
                }}
            >
                {/* Darker Overlay for Contrast */}
                <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/30 via-neutral-900/50 to-neutral-900/70"></div>
            </div>

            {/* z-10: Main Content */}
            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

                    {proofPoints.map((point, index) => (
                        <motion.div
                            key={point.title}
                            className="p-5 border border-white/20 rounded-xl bg-white/5 backdrop-blur-md shadow-lg transition-all duration-300 hover:border-white/50 hover:bg-white/10"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div className="flex items-center gap-3 mb-3">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${point.color} bg-black/30`}>
                                    {point.icon}
                                </div>
                                <h3 className="text-lg font-bold text-white leading-tight">{point.title}</h3>
                            </div>
                            <p className="text-sm text-white/70 leading-relaxed min-h-[4rem]">{point.description}</p>
                        </motion.div>
                    ))}

                </div>
            </div>
        </section>
    );
};

export default SubHeroProofPoints;